import { CompTransactions } from '../zillow/types.ts';

/** @deprecated */
export const makeCompMonthMap = (
  comps: CompTransactions,
  compSequence: string[],
): Record<string, string[]> => {
  const map: Record<string, string[]> = {};
  Object.entries(comps).forEach(([compID, comp]) => {
    const status = comp.listingStatus;
    if (status !== 'SettledSale') return;

    const month = comp.contractMonth ?? comp.closeMonth;
    if (month) {
      if (!map[month]) map[month] = [];

      // Find the comp index
      const index = compSequence.findIndex((id) => id === compID);
      index >= 0 && map[month]?.push(`${index + 1}`);
    }
  });

  return map;
};
